import { toastServerError } from "helpers";
import { useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteWarehouse } from "../../apis";
import { DeleteWarehouseModalProps } from "./DeleteWarehouseModal.types";

const DeleteWarehouseModal = ({
  isOpen,
  onClose,
  warehouse,
}: DeleteWarehouseModalProps) => {
  const { t } = useTranslation();
  const refetchWarehouses = useRefetchQuery(["warehouses"]);

  const { mutate: deleteWarehouse, isLoading } = useDeleteWarehouse({
    onSuccess: () => {
      refetchWarehouses();
      toast.success(t("Warehouse was deleted successfully"));
      onClose();
    },
    // Backend returns 409 if the warehouse still has boxes assigned.
    onError: toastServerError,
  });

  const onDelete = () => {
    if (warehouse) deleteWarehouse(warehouse.id);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      isLoading={isLoading}
      title="Delete Warehouse"
      okText="Delete"
      onClose={onClose}
      onOk={onDelete}
    >
      {t(
        "Are you sure you want to delete this warehouse? It must have no boxes assigned.",
      )}
    </Modal>
  );
};

export default DeleteWarehouseModal;
